<ul class="bmc-tree-node">
  <li *ngFor="let item of tree | orderByTranslate : '' : 'value'" class="bmc-tree-node__item">
    <span *ngIf="!item.isDisabled"
    [class.item-pointer]="isClickable(item)"
    (click)="getInfo(item);this.loading = true;$event.stopPropagation();"
    title="{{ item.value | translate }}">
        <svg *ngIf="item.iconClass && item.iconClass == '#key' && !item.hasNodes"
        class="bmc-tree-node__arrow bmc-tree-node__arrow--disabled">
          <use href="#icon-arrow-right-bold"></use>
        </svg>
        <svg *ngIf="item.iconClass && item.iconClass == '#key' && item.hasNodes" class="bmc-tree-node__arrow">
            <use *ngIf="!item.isExpanded && !isSelected(item)" href="#icon-arrow-right-bold"></use>
            <use *ngIf="(item.isExpanded || isSelected(item))" href="#icon-arrow-down-bold"></use>
        </svg>
        <img *ngIf="item.base64Icon" class="bmc-tree-node__key-icon" [alt]="item.name" [src]="'data:image/png;base64,'+item.base64Icon" />
        <svg *ngIf="item.iconClass && item.iconClass == '#keys' && item.id" class="bmc-tree-node__key-icon bz-color--neutral-400">
            <use  href="#icon-key"></use>
        </svg>
        <svg *ngIf="item.iconClass && item.iconClass == '#keys' && !item.id" class="bmc-tree-node__key-icon bz-color--neutral-400 bmc-tree-node__key-icon--disabled">
            <use  href="#icon-key"></use>
        </svg>
        <span class="bmc-tree-node__text" [class.bmc-tree-node__text--disabled]="(item.iconClass && item.iconClass == '#key' && !item.hasNodes) ||
        (item.iconClass && item.iconClass == '#keys' && !item.id)"
        [class.selected]="isSelected(item)">{{ item.value | translate }}</span>
    </span>
    <div *ngIf="item.children && item.children.length > 0">
      <bz-tree *ngIf="item.isExpanded" [tree]="item.children" (clickNodeEvent)="getInfo($event)" [currentId]="currentId" [currentParentId]="currentParentId"></bz-tree>
    </div>
  </li>
</ul>
